<template>
    <div class="container">
        <h1>Le développement de Cardano</h1>

        <p class="intro">
            Cardano est un projet crypto pas comme les autres. Son processus de développement est à contre-courant de la plupart des autres cryptomonnaies. Explications.
        </p>

        <p>
            Cardano a été fondée par <i>Charles Hopkins</i>, l'un des cofondateurs d'Ethereum. Il a présenté, lors de l'introduction du projet, l'objectif de Cardano, qui est avant, selon ses dires, tout d'apprendre des erreurs d'Ethereum qui
            rencontre d'important blocages sur des problématiques de scalabilité, de performances et de gouvernance.
        </p>

        <h2>Qui est derrière Cardano ?</h2>
        <p>
            Cardano est un vaste projet, gouverné par différentes organisations. Voici comment se présente sa gouvernance.
        </p>

        <h3>La Fondation Cardano</h3>
        <p>
            A la tête du projet Cardano, la Fondation Cardano, une organisation à but non lucratif. Basée en Suisse, la Cardano Fondation a réalisé une <a href="https://fr.wikipedia.org/wiki/Initial_coin_offering">ICO</a> de 62.2 millions de dollars
            en Octobre 2015.
        </p>

        <p>
            Frederik Gregaard, le CEO actuel de la fondation, est un ancien directeur financier de <a href="https://fr.wikipedia.org/wiki/PricewaterhouseCoopers"> PriceWaterhouseCooper</a>, l'un des "big four" des cabinet d'audit comptable (avec
            KPMG, Deloitte et Ernst&amp;Young). Il indique <a href="https://www.crypto-news-flash.com/ceo-of-the-cardano-foundation-strategy-for-the-next-50-100-years/"> poursuivre actuellement une stratégie sur 50 à 100 ans</a>.
        </p>

        <p>
            Voici les missions principales (dans l'ordre) de la fondation Cardano:
        </p>
        <ul>
            <li>Favoriser l'adoption de Cardano</li>
            <li>Mettre en place une législation pour rendre Cardano intéropérable avec les différents standards légaux et commerciaux</li>
            <li>Supporter et faire grandir la communauté Cardano</li>
            <li>Assurer les intérêts des actionnaires de Cardano (les détenteurs d'ADAs)</li>
            <li>Faciliter les partenariats avec le monde de l'industrie</li>
        </ul>

        <p>Elle s'est constituée pour cela <a href="https://cardanofoundation.org/en/about-us/">une jolie petite équipe</a>:</p>
        <ul>
            <li>5 membres au conseils</li>
            <li>13 informaticiens</li>
            <li>4 PR (public relations)</li>
            <li>3 marketing</li>
            <li>5 community managers</li>
        </ul>

        <h3>IOHK: l'entreprise qui développe la blockchain</h3>
        <p>
            Le développement d'une blockchain aussi ambitieuse que Cardano est une tâche des plus compliquées qui soit: personne n'a, jusqu'à présent, réussi un tel exploit (pas même Bitcoin ou Ethereum).
        </p>

        <p>
            C'est IOHK qui a été affecté au projet, une entreprise créé par <i>Charles Hoskinson</i>. Hoskinson est l'un des 8 fondateurs d'Ethereum, et l'un des deux co-fondateurs du projet Cardano. Mais il ne suffit pas d'un développeur Rockstar
            pour développer Cardano, c'est pourquoi il a jugé bon de <a href="https://iohk.io/en/team/">se faire accompagner un peu</a>. Avec lui, il y a à IOHK:
        </p>
        <ul>
            <li>2 fondateurs</li>
            <li>5 directeurs</li>
            <li>30+ chercheurs</li>
            <li>120+ ingénieurs</li>
            <li>10 commerciaux</li>
        </ul>

        <p>
            Contrairement à la grande majorité des blockchains qui se basent uniquement sur un
            <a href="https://cryptoast.fr/quest-ce-quun-white-paper-livre-blanc/">whitepaper</a>, Cardano est un projet aux fortes racines universitaires qui prend très au sérieux son approche du développement. Les développements sont basées sur des
            recherches, qui ont été financées mais aussi <a href="https://iohk.io/en/research/library/">publiées par IOHK</a>, afin qu'elles soient <u>évaluées et revues par les pairs</u>. Avant que les protocoles soient implémentés, ils passent par
            cette phase de revue et de critiques, nécessaires pour déceler les failles dans les protocoles.
        </p>

        <p>Le langage par défaut est Haskell, langage qui permet les preuves mathématiques du niveau de fonctionnement du logiciel. Dans la blockchain Cardano, le niveau de sécurité est <u>prouvé</u>.</p>

        <p>
            Malgré son approche prudente (et donc, nécessairement plus lente), l'équipe d'IOHK ne chôme pas: Cardano est le projet qui a connu le plus d'activité sur Github en 2019 (devant Ethereum)
        </p>
        <img v-lazy-load data-src="/img/doc/cardano-most-developped-2019.webp" alt="Cardano, le projet crypto le plus actif en 2019" />

        <h3>Emurgo: la branche commerciale de Cardano</h3>
        <p>
            Emurgo est la branche commerciale de Cardano. L'entreprise est chargée de créer des ponts entre la blockchain et le monde économique: Etats, entreprises, particuliers.
        </p>

        <p>
            Emurgo commercialise des solutions industrielles basées sur la blockchain. Entre autres:
        </p>
        <ul>
            <li>Tracabilité des produits (usage alimentaire, cosmétique, médical)</li>
            <li>Stockage sécurisé d'information (médical)</li>
            <li>Automatisation des transferts d'énergie (smart contracts)</li>
            <li>Application financières (assurances, etc)</li>
        </ul>

        <p><a href="https://emurgo.io/who-we-are">L'équipe d'Emurgo</a> est aujourd'hui constituée de 6 dirigeants pour 43 employés. Elle semble actuellement concentrée sur les marchés anglophones, asiatiques, indiens et indonésiens.</p>

        <h2>Le futur du développement de Cardano</h2>
        <p>
            Si Cardano est aujourd'hui un projet correctement staffé, il n'est jamais bon pour une blockchain d'avoir une centralisation de sa gourvenance. La phase Voltaire du projet, la dernière, prévoit de décentraliser complètement la gouvernance
            pour remettre les évolutions de la blockchain complètement dans les mains des actionnaires de Cardano, les détenteurs de la cryptomonnaie ADA.
        </p>

        <p>
            <a href="https://www.youtube.com/watch?v=3_wJOF4Y8gU">Charles Hoskinson s'est exprimé sur la décentralisation de la gouvernance</a>. Dans ce but, Cardano va casser les protocoles de décisions en <b>processus</b>, et ces processus seront
            progressivement intégrés sur la blockchain. Avec plus de 3000 personnes actuellement engagées dans les discussions sur la structure de la blockchain et son futur, il n'y a aucun doute que de bonnes idées émergeront de la communauté. Au
            fur et à mesure des discussions, des propositions finales émergeront des différentes communauté, et pourront être soumises au vote, directement sur la blockchain.
        </p>

        <p>
            La Blockchain pourra alors réguler (par le biais des actionnaires) quand, comment et à qui l'argent sera distribué pour le projet. Les fondateurs de projets seront responsable de fournir des données et informations sur les évolutions du
            projet à la communauté, et seront libre de se faire suivre de près par certains membres afin de faciliter l'accès à la suite du financement.
        </p>

        <p>
            Il semble évident qu'IOHK, après avoir accompli les 5 phases critiques du développement de la blockchain Cardano, continuera d'être un acteur de celle-ci, car ils auront gagné la confiance de la communauté (et, disons le: ils l'auront
            mérité). Mais ce processus permettra de voir émerger d'autres entreprises, développeurs, et idées capables de faire évoluer la blockchain, et capables de travailler simultanément sur leurs évolutions.
        </p>

        <div class="button-line">
            <a class="btn btn-outline-primary btn-left" href="/doc-cardano/qu-est-ce-que-cardano">
                <i class="fa fa-chevron-left"></i>
                <i>Précédent:</i>
                <b>Qu'est-ce que Cardano ?</b>
            </a>
            <a class="btn btn-outline-primary btn-right" href="/doc-cardano/les-phases-de-cardano-roadmap">
                <i>Suivant:</i>
                <b>Les phases de Cardano</b>
                <i class="fa fa-chevron-right"></i>
            </a>
        </div>
    </div>
</template>

<script>
import createHeader from "../../js/meta.js";

export default {
    layout: "DocLayout",
    head: createHeader({
        title: "Le processus de développement de Cardano - Stakepool.fr",
        description: "Découvrez comment la blockchain Cardano est développée",
    }),
};
</script>
